export default __webpack_public_path__ + "static/media/Thorin's Letter to Bilbo_07.90bf7380.jpg";